class e {
  constructor() {
    this.decimalSeparator = ".";
  }
  zipcode(r) {
    return r.match(/^[0-9]/) ? "9999" : "*a 9999";
  }
  birthdate() {
    return "39-19-2999";
  }
}
export {
  e as default
};
